<template>
    <div>
        {{ $t('redirecting') }}
    </div>
</template>

<script>
import api from '@/services/api'
import oauth from '@/services/oauth-api'
import AuthService from '@/services/auth'

export default {
    name: 'LoginCognitoAD',
    created() {
        const idToken = this.getIdTokenFromUrl()
        if (idToken) {
            this.authOnCognitoLoginAD(idToken)
        } else {
            this.redirectToErrorPage()
        }
    },
    computed: {
        authService() {
            return AuthService(api, oauth)
        },
    },
    methods: {
        authOnCognitoLoginAD(idToken) {
            this.authService
                .loginWithCognito(idToken)
                .then(() => {
                    this.$router.push({ name: 'Home' })
                })
                .catch(() => {
                    this.redirectToErrorPage()
                })
        },
        getIdTokenFromUrl() {
            const urlHash = this.$route.hash
            if (!urlHash) {
                return
            }

            return this.getParameterFromUrlHash(urlHash, 'id_token')
        },
        redirectToErrorPage() {
            this.$router.push({
                name: 'Error',
                params: { status: '401' },
            })
        },
        getParameterFromUrlHash(urlHash, param) {
            const queryParams = urlHash.replace('#', '')
            const urlSearchParams = new URLSearchParams(queryParams)
            return urlSearchParams.get(param)
        },
    },
    i18n: {
        messages: {
            'pt-BR': {
                redirecting: 'Redirecionando...',
            },
            'en-US': {
                redirecting: 'Redirecting...',
            },
            'es-ES': {
                redirecting: 'Redireccionando...',
            },
        },
    },
}
</script>
